module.exports = __webpack_public_path__ + "app-static/img/p_02.96a9f768.jpg";